import { useEffect, useRef } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import SignatureCanvas from "react-signature-canvas";
import { useTranslation } from "react-i18next";
import RequiredLabel from "components/RequiredLabel";

export default function RecordsRelease() {
  const sigRef = useRef(null);
  const { control, watch, setValue } = useFormContext();
  const { t } = useTranslation();

  const savedSignature = watch("releaseOfInformation");

  useEffect(() => {
    if (
      sigRef.current &&
      (
        !savedSignature ||
        typeof savedSignature !== "string" ||
        !savedSignature.startsWith("data:image")
      )
    ) {
      sigRef.current.clear();
    }
    // eslint-disable-next-line
  }, [savedSignature]);

  const handleClearSignature = () => {
    if (sigRef.current) sigRef.current.clear();
    setValue("releaseOfInformation", null, {
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  const handleEndSignature = () => {
    if (!sigRef.current) return;

    if (sigRef.current.isEmpty()) {
      setValue("releaseOfInformation", null, {
        shouldDirty: true,
        shouldTouch: true,
      });
      return;
    }

    const dataUrl = sigRef.current.toDataURL("image/png");
    setValue("releaseOfInformation", dataUrl, {
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  return (
    <Box>
      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mt: 1 }}>
        <Box
          backgroundColor="divider"
          sx={{ p: 2, borderTopLeftRadius: 8, borderTopRightRadius: 8 }}
        >
          <Typography variant="h6">{t("Release of Student Records")}</Typography>
        </Box>

        <Box p={2}>
          <Typography>
            {t("By agreeing below you are giving your school authority to print and send a communication to previous school to release the student's academic records.")}
          </Typography>
        </Box>

        <Grid container spacing={2} p={2}>
          <Grid item xs={12}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              <Typography sx={{ fontWeight: 500 }}><RequiredLabel>{t("Signature")}</RequiredLabel></Typography>
              <Controller
                name="releaseOfInformation"
                control={control}
                render={({ field, fieldState }) => (
                  <Box
                    sx={{
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 2,
                      backgroundColor: "background.paper",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    {typeof field.value === "string" &&
                    field.value.startsWith("data:image") ? (
                      <Box
                        component="img"
                        src={field.value}
                        alt="signature"
                        sx={{
                          width: "100%",
                          height: 200,
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                    ) : (
                      <SignatureCanvas
                        ref={sigRef}
                        penColor="black"
                        canvasProps={{
                          style: {
                            width: "50%",
                            height: 150,
                            display: "block",
                          },
                        }}
                        onEnd={handleEndSignature}
                        onClear={handleClearSignature}
                      />
                    )}
                    {fieldState.error && (
                      <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                        {fieldState.error.message}
                      </Typography>
                    )}
                  </Box>
                )}
              />
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button variant="outlined" onClick={handleClearSignature}>
                  {t("Clear Signature")}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      {/* <pre style={{ background: "#f7f7f7", padding: 16, overflow: "auto" }}>
        {JSON.stringify(data, null, 2)}
      </pre> */}
    </Box>
  );
}
